import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { endpoints } from "../services/endpoints";
import { api } from "../services/api";

export default function Login() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const [dni, setDni] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await api.post(endpoints.auth.login, {
        dni,
        password,
      });

      if(response.data.mustChangePassword){
        navigate("/change-password", {
          state: { operator_id: response.data.operator_id}
        });
        return;
      }

      const token = response.data.access_token;
      const user = response.data.user;

      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));

      if (user?.preferred_language) {
        const lang = user.preferred_language.toLowerCase();
        i18n.changeLanguage(lang);
        localStorage.setItem("i18nextLng", lang);
      }

      navigate("/");
    } catch (err) {
      setError(err.message);
      console.error("Error al iniciar sesión:", err);
      alert(
        t("login.error", "Error al iniciar sesión:") +
          " " +
          (err.message || t("login.serverDown", "Servidor no disponible"))
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      {/* Fondo con opacidad */}
      <div className="absolute left-0 w-full h-full bg-black opacity-60 z-0">
        <img
          src="/img/backend.webp"
          alt="Background"
          className="w-full h-full object-cover object-center"
        />
      </div>

      {/* Capa de contenido */}
      <div className="absolute inset-0 flex items-center justify-center z-10">
        <form
          onSubmit={handleLogin}
          className="bg-white p-8 rounded shadow-md w-full max-w-sm flex flex-col gap-4"
        >
          <img
            src="/img/Dealsys_soloLogo.png"
            alt="logo"
            className="h-20 w-20 mx-auto "
          />
          <img
            src="/img/sysventory.png"
            alt="logo"
            className="h-30"
          />

          <h2 className="text-2xl font-semibold text-center text-[#01839C]">
            {t("login.title")}
          </h2>

          {error && (
            <div className="bg-red-100 text-red-700 p-2 rounded" role="alert">
              {error}
            </div>
          )}

          <input
            type="text"
            placeholder={t("login.fields.dni")}
            value={dni}
            onChange={(e) => setDni(e.target.value)}
            className="border rounded px-4 py-2"
            required
          />

          <input
            type="password"
            placeholder={t("login.fields.password")}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="border rounded px-4 py-2"
            required
          />

          <button
            type="submit"
            disabled={loading}
            className={`py-2 rounded text-white ${
              loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-[#01839C] hover:bg-[#016b7c]"
            }`}
          >
            {t("login.actions.submit")}
          </button>

          <button
            type="button"
            onClick={() => navigate("/forgot-password")}
            className="text-sm text-[#01839C] hover:underline text-center"
          >
            {t("login.actions.forgotPassword", "¿Has olvidado tu contraseña?")}
          </button>
        </form>
      </div>
    </div>
  );
}
